import { ScrollGroup } from '@/game/GameComponents/PhaserGame/Utils/PhaserLayout/ScrollGroup';
import {
  shouldSubmitOnPointerUp,
  SizedObject,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import { DEFAULT_CURSOR_PATH } from '@/game/GameComponents/Utils/GameSpriteAssetsMap';

export class ScrollGroupItem {
  constructor(
    scrollGroup: ScrollGroup,
    interactiveElements: SizedObject[],
    onSubmittedCallback?: () => void,
  ) {
    interactiveElements.forEach((element) => {
      element.setInteractive({ cursor: DEFAULT_CURSOR_PATH });
      element.scene.input.setDraggable(element);
      element.on('drag', (e: any) => {
        scrollGroup.handleDrag(e);
      });

      element.on('wheel', (e: any) => {
        scrollGroup.handleScroll(e);
      });

      element.on('pointerup', (e: any) => {
        if (shouldSubmitOnPointerUp(e)) {
          onSubmittedCallback?.();
        }
      });
    });
  }
}
